import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";
import { Constants } from "@/helpers/constants";

import { ILogger, LogLevel, HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";
import store from "@/store";
import { StorePerson, StoreNotification } from "@/store/constants";
import { PersonService } from "@/services/api/person";

export const NotificationService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.NOTIFICATION, null, wait).then((data) => {
            for (let i = 0; i < data.length; i++) {
                const r = data[i];
                r.isReaded = C.Bool(r.isReaded);
                r.personNotificationTypeName = J.FindKey(Constants.Notification.Type, r.personNotificationType);
            }
            callback(data);
        });
    },
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.NOTIFICATION + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },
    Delete(id, callback) {
        const j = {};
        Ajax.Api(MethodType.Delete, Enums.SERVICE.NOTIFICATION + "/" + id, j).then((data) => {
            callback(data);
        });
    },
    async ListenServer() {
        if (await PersonService.GetTokenIsLogin()) {
            //https://cdn.pixabay.com/download/audio/2024/02/19/audio_e4043ea6be.mp3?filename=level-up-191997.mp3
            const sound = new Audio('/assets/sound/notification.mp3'); // Ses dosyas�n�n yolu

            const connection = new HubConnectionBuilder()
                .withUrl(appData.serverBase + "hubs/person/notification", {
                    accessTokenFactory: async () => {
                        return await PersonService.GetAccessRefreshToken();
                    }
                }, HttpTransportType.WebSockets)
                //.configureLogging(LogLevel.Information)
                .configureLogging(LogLevel.Warning)
                .withAutomaticReconnect()
                .build();
            await connection
                .start()
                .then(async () => {
                    //const connectionId = connection.connectionId;
                    await connection.on("receiveError", (error) => {
                        console.log(error);
                    });
                    await connection.on("receiveNotificationAdd", (id, notificationType, subject, message, data, isReaded, sendDate) => {
                        try {
                            console.log(`${id}, ${notificationType}, ${subject}, ${message}, ${data}, ${isReaded}, ${new Date(sendDate)}`);
                            store.dispatch(StoreNotification.setList, [{ id, notificationType, subject, message, data, isReaded, sendDate }]);
                            if ('Notification' in window) {
                                Notification.requestPermission().then(permission => {
                                    if (permission === 'granted') {
                                        // Bildirim olu�tur
                                        const notification = new Notification(subject, {
                                            body: message,
                                            sound: '/assets/sound/notification.mp3' // Ses dosyas�
                                        });
                                    }
                                }).catch(error => {
                                    console.error('Notification permission error: ', error);
                                });
                            }
                            //sound.play().catch(error => {
                            //    console.error('Notification sound error:', error);
                            //});
                        }
                        catch (ex2) {
                            console.warn(ex2.message);
                        }
                    });
                    setTimeout(async () => {
                        try {
                            if (connection.state === HubConnectionState.Connected) {
                                const endDate = store.getters[StoreNotification.getEndSendDateUnReaded];
                                await connection.invoke("receiveNotificationGetUnReaded", endDate == null ? null : new Date(endDate));
                            }
                        }
                        catch (ex) {
                            console.warn(ex.message);
                        }
                    }, 1000);
                })
                .catch(err => {
                    console.error(err);
                });
        }
        else {
            setTimeout(async () => {
                await this.ListenServer();
            }, 10000);
        }
    }
};